<!-- SYRC-7544: centered modal (first non-minimized import). -->
<div *ngIf="modalImport$ | async as job" class="import-progress-backdrop">
  <div
    class="import-progress-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="titleFor(job)"
  >
    <div class="import-progress-modal__head">
      <span
        class="import-progress-modal__icon material-icons"
        aria-hidden="true"
        >upload</span
      >
    </div>

    <h2 class="import-progress-modal__title">{{ titleFor(job) }}</h2>
    <p class="import-progress-modal__subtitle">{{ subtitleFor(job) }}</p>
    <p class="import-progress-modal__hint">{{ leaveHint }}</p>

    <!-- Queued: no track, just the "waiting to start" subtitle above. -->
    <app-progress-bar
      *ngIf="showTrack(job)"
      variant="modal"
      [percent]="job.percentComplete"
      [indeterminate]="isIndeterminate(job)"
      [label]="phaseFor(job)"
      [showPercent]="!isIndeterminate(job)"
    ></app-progress-bar>

    <p *ngIf="showTimeRemaining(job)" class="import-progress-modal__eta">
      {{ timeRemainingLabel }}
      <strong>{{ timeRemainingText(job) }}</strong>
    </p>

    <div class="import-progress-modal__actions">
      <button
        type="button"
        class="import-progress-modal__bg-btn"
        (click)="continueInBackground(job.importJobId)"
      >
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        {{ continueInBackgroundLabel }}
      </button>
    </div>
  </div>
</div>

<!-- Minimized pills (bottom-right). "Click to view progress" expands the modal. -->
<div class="import-progress-pill-stack">
  <div
    *ngFor="let job of pillImports$ | async; trackBy: trackByImportJobId"
    class="import-progress-pill"
    role="status"
    aria-live="polite"
    [attr.aria-label]="titleFor(job)"
  >
    <div class="import-progress-pill__header">
      <span
        class="import-progress-pill__spinner material-icons"
        aria-hidden="true"
        >autorenew</span
      >
      <span class="import-progress-pill__label">{{ titleFor(job) }}</span>
      <span
        *ngIf="!isIndeterminate(job) && showTrack(job)"
        class="import-progress-pill__percent"
        >{{ job.percentComplete }}%</span
      >
    </div>

    <app-progress-bar
      *ngIf="showTrack(job)"
      variant="toast"
      [percent]="job.percentComplete"
      [indeterminate]="isIndeterminate(job)"
      [showPercent]="false"
    ></app-progress-bar>

    <!-- Re-open the full progress modal. -->
    <button
      type="button"
      class="import-progress-pill__view"
      (click)="viewProgress(job.importJobId)"
      [attr.aria-label]="clickToViewLabel"
    >
      <span class="material-icons" aria-hidden="true">visibility</span>
      {{ clickToViewLabel }}
    </button>
  </div>
</div>
